<div class="container">
  <div class="row pb-5">
    <div class="col-xl-8 col-lg-12 offset-xl-2">
      <h3>Información del participante</h3>
      <div class="info__box">
        <div class="cont_importante">
          <img src="../../../../../../assets/images/icons/icon-info-box.svg" alt="Importante">
          <div class="tit_info">Importante</div>
        </div>
        <p>Condiciones de participación en el Programa de Animación Red.</p>
        <button type="button" class="btn btn-secondary-action ms-auto"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> Condiciones programa</button>
      </div>
      <form [formGroup]="dataform" (ngSubmit)="save()" class="form__simple mt-2">

        <div class="row align-items-center mb-3">
          <div class="col-lg-2 col-md-12">
            <label class="form-label">Nombre</label>
          </div>
          <div class="col-lg-10 col-md-12">
            <input formControlName="Name" type="text" class="form-control" placeholder="Nombre" [ngClass]="{'is-invalid':dataform.get('Name').invalid && (!dataform.get('Name').pristine || submitted == 1) , 'is-valid':dataform.get('Name').valid && !dataform.get('Name').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Name'].errors || !dataform.controls['Name'].errors['required']">
                Nombre requerido.
              </div>
              <div [hidden]="!dataform.controls['Name'].errors || !dataform.controls['Name'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">Apellidos</label>
          </div>
          <div class="col-lg-10 col-md-12">
            <input formControlName="Surname" type="text" class="form-control" placeholder="Apellidos" [ngClass]="{'is-invalid':dataform.get('Surname').invalid && (!dataform.get('Surname').pristine || submitted == 1) , 'is-valid':dataform.get('Surname').valid && !dataform.get('Surname').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Surname'].errors || !dataform.controls['Surname'].errors['required']">
                Apellidos requeridos.
              </div>
              <div [hidden]="!dataform.controls['Surname'].errors || !dataform.controls['Surname'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">DNI</label>
          </div>
          <div class="col-lg-4 col-md-12 mb-3">
            <input formControlName="Dni" type="text" class="form-control" placeholder="DNI" [ngClass]="{'is-invalid':dataform.get('Dni').invalid && (!dataform.get('Dni').pristine || submitted == 1) , 'is-valid':dataform.get('Dni').valid && !dataform.get('Dni').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Dni'].errors || !dataform.controls['Dni'].errors['required']">
                DNI requerido.
              </div>
              <div [hidden]="!dataform.controls['Dni'].errors || !dataform.controls['Dni'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-12">
            <label class="form-label">Fecha de nacimiento</label>
          </div>
          <div class="col-lg-3 col-md-12 mb-3">
            <input formControlName="Birthdate" value="{{ userModel?.Birthdate | date:'yyyy-MM-dd' }}" type="date" #birthdate (click)="updateBirthdate(birthdate.value)" class="form-control" [ngClass]="{'is-invalid':dataform.get('Birthdate').invalid && (!dataform.get('Birthdate').pristine || submitted == 1) , 'is-valid':dataform.get('Birthdate').valid && !dataform.get('Birthdate').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Birthdate'].errors || !dataform.controls['Birthdate'].errors['required']">
                Fecha de nacimiento requerida.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">Email personal</label>
          </div>
          <div class="col-lg-4 col-md-12 mb-3">
            <input formControlName="EmailPersonal" type="text" class="form-control" placeholder="Email personal" [ngClass]="{'is-invalid':dataform.get('EmailPersonal').invalid && (!dataform.get('EmailPersonal').pristine || submitted == 1) , 'is-valid':dataform.get('EmailPersonal').valid && !dataform.get('EmailPersonal').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['EmailPersonal'].errors || !dataform.controls['EmailPersonal'].errors['required']">
                Email personal requerido.
              </div>
              <div [hidden]="!dataform.controls['EmailPersonal'].errors || !dataform.controls['EmailPersonal'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-12">
            <label class="form-label">Móvil personal</label>
          </div>
          <div class="col-lg-4 col-md-12 mb-3">            
            <input formControlName="PhonePersonal" type="text" class="form-control" placeholder="Teléfono personal" [ngClass]="{'is-invalid':dataform.get('PhonePersonal').invalid && (!dataform.get('PhonePersonal').pristine || submitted == 1) , 'is-valid':dataform.get('PhonePersonal').valid && !dataform.get('PhonePersonal').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['PhonePersonal'].errors || !dataform.controls['PhonePersonal'].errors['required']">
                Teléfono personal requerido.
              </div>
              <div [hidden]="!dataform.controls['PhonePersonal'].errors || !dataform.controls['PhonePersonal'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">Provincia</label>
          </div>
          <div class="col-lg-10 col-md-12">
            <select2 formControlName="IdProvince" [data]="provincesData" [ngClass]="{'is-invalid':dataform.get('IdProvince').invalid && (!dataform.get('IdProvince').pristine || submitted == 1) , 'is-valid':dataform.get('IdProvince').valid && !dataform.get('IdProvince').pristine}"></select2>
            <div class="invalid-feedback" style="top:auto !important">
              <div [hidden]="!dataform.controls['IdProvince'].errors || !dataform.controls['IdProvince'].errors['required']">
                Provincia requerida
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">Localidad</label>
          </div>
          <div class="col-lg-10 col-md-12">
            <input formControlName="Location" type="text" class="form-control" placeholder="Localidad" [ngClass]="{'is-invalid':dataform.get('Location').invalid && (!dataform.get('Location').pristine || submitted == 1) , 'is-valid':dataform.get('Location').valid && !dataform.get('Location').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Location'].errors || !dataform.controls['Location'].errors['required']">
                Localidad requerida.
              </div>
              <div [hidden]="!dataform.controls['Location'].errors || !dataform.controls['Location'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">Dirección personal</label>
          </div>
          <div class="col-lg-10 col-md-12">
            <input formControlName="Address" type="text" class="form-control" placeholder="Dirección" [ngClass]="{'is-invalid':dataform.get('Address').invalid && (!dataform.get('Address').pristine || submitted == 1) , 'is-valid':dataform.get('Address').valid && !dataform.get('Address').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Address'].errors || !dataform.controls['Address'].errors['required']">
                Dirección requerida.
              </div>
              <div [hidden]="!dataform.controls['Address'].errors || !dataform.controls['Address'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">

          <div class="col-lg-2 col-md-12">
            <label class="form-label">CP</label>
          </div>
          <div class="col-lg-10 col-md-12">
            <input formControlName="Cp" type="text" class="form-control" placeholder="CP" [ngClass]="{'is-invalid':dataform.get('Cp').invalid && (!dataform.get('Cp').pristine || submitted == 1) , 'is-valid':dataform.get('Cp').valid && !dataform.get('Cp').pristine}">
            <div class="invalid-feedback">
              <div [hidden]="!dataform.controls['Cp'].errors || !dataform.controls['Cp'].errors['required']">
                CP requerido.
              </div>
              <div [hidden]="!dataform.controls['Cp'].errors || !dataform.controls['Cp'].errors['maxlength']">
                Límite de caracteres superado.
              </div>
            </div>
          </div>
        </div>

        <div class="pt-4 clearfix">
          <div class="float-end mr-3">
            <button type="submit" class="btn btn-primary"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
          </div>
        </div>
      </form>
    </div>

  </div>
</div>
